import React, { useCallback } from 'react';
import { useRecordContext } from 'react-admin';

import Typography from '@mui/material/Typography';

import ModalButton from './ModalButton';

import { useConstantContext } from './ConstantsContext';
import useCustomRpc from '../../hooks/useCustomRpc';

const RevertDebtCollectionButton = () => {
  const record = useRecordContext();
  const { constants } = useConstantContext();
  const { accountStatuses } = constants;

  const {
    id: accountId,
    status,
    sentToDebtCollectionAt,
  } = record || {};

  const { mutate: revertDebtCollection } = useCustomRpc({
    httpMethod: 'PATCH',
    path: `account/${accountId}/revert-debt-collection`,
    successMessage: 'Debt collection reverted',
    errorMessage: 'Failed reverting debt collection',
    shouldRefresh: true,
  });

  const isEligibleForRevertDebtCollection = status === accountStatuses.CANCELLED
    && sentToDebtCollectionAt;

  const onClickClose = useCallback(() => {
    revertDebtCollection();
    return true;
  }, [revertDebtCollection]);

  if (!isEligibleForRevertDebtCollection) return null;

  return (
    <ModalButton
      title="Revert Debt Collection"
      onClick={onClickClose}
      right
    >
      <Typography variant="body2" align="center">Are you sure to revert the debt collection information for this account?</Typography>
    </ModalButton>
  );
};

export default RevertDebtCollectionButton;
